import { createContext } from "react";
import { User } from "../../types";

export type UpdatableUserFields = Pick<User, "name" | "firstName" | "lastName">;

interface AuthContextInterface {
  authToken: string | null;
  isAuthenticated: boolean;
  // Indicates if the user was authenticated from a URL token "?a=" given by the add-in.
  isAuthenticatedFromUrl: boolean;
  logout: () => void;
  updateUser: (user: UpdatableUserFields) => void;
  user?: User;
  hasSubscription?: boolean;
}

export const AuthContext = createContext<AuthContextInterface>({
  authToken: null,
  isAuthenticated: false,
  isAuthenticatedFromUrl: false,
  logout: () => {},
  updateUser: () => {},
  user: undefined,
  hasSubscription: false,
});
